import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from '@/icons';

interface CreateFamilyCardProps {
  allowed: boolean;
  onClick: () => void;
}

const CreateFamilyCard: React.FC<CreateFamilyCardProps> = ({ allowed, onClick }) => {
  const { t } = useTranslation('screens');

  return (
    <button
      type="button"
      className="create-card"
      data-tour="create-family-card"
      disabled={!allowed}
      onClick={onClick}
      title={allowed ? t('createFamilyCard.titleAllowed') : t('createFamilyCard.titleRestricted')}
    >
      <div className="create-card__icon">
        <Plus width={24} height={24} />
      </div>
      <h3 className="create-card__title">{t('createFamilyCard.title')}</h3>
      <p className="create-card__sub">{t('createFamilyCard.description')}</p>
    </button>
  );
};

export default CreateFamilyCard;
